<app-center-view title="Reset Password" [isLoading]="isLoading" [error]="error">
  <form [formGroup]="recoverForm">
    <app-input-form
      label="Reset your password"
      icon="lock"
      note="รหัสผ่านมีความยาวอย่างน้อย 6 ตัวอักษร"
    >
      <input
        type="password"
        formControlName="password"
        placeholder="Password"
        required
        autofocus
        (keyup.enter)="resetPassword()"
      />
    </app-input-form>
    <app-input-form icon="lock">
      <input
        type="password"
        formControlName="confirmPassword"
        placeholder="Confirm Password"
        required
        (keyup.enter)="resetPassword()"
      />
    </app-input-form>
  </form>
  <button mat-raised-button appThemedButton [disabled]="!recoverForm.valid" (click)="resetPassword()">
    Confirm
  </button>
</app-center-view>
